import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { TermsOfUseComponent } from './terms-of-use-component';

export function TermsOfUseFactory() {
  return (
    <BaseLayoutFactory>
      <TermsOfUseComponent />
    </BaseLayoutFactory>
  );
}
